// src/components/BackToTop.jsx
import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button className="back-to-top" onClick={scrollToTop} aria-label="Back to top">
          <FaArrowUp />
        </button>
      )}
      <style>{`
        .back-to-top {
          position: fixed;
          bottom: 2rem;
          left: 2rem;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: #0B5E6B;
          color: white;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 1000;
          box-shadow: 0 4px 15px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
        }
        .back-to-top:hover {
          transform: translateY(-5px);
          background: #094953;
          box-shadow: 0 8px 25px rgba(0,0,0,0.15);
        }
        [data-theme='dark'] .back-to-top {
          background: #1e1e1e;
          color: #14a1bb;
          border: 1px solid #2d3436;
          box-shadow: 0 4px 15px rgba(0,0,0,0.4);
        }
        [data-theme='dark'] .back-to-top:hover {
          background: #14a1bb;
          color: white;
          border-color: #14a1bb;
        }
        @media (max-width: 768px) {
          .back-to-top {
            bottom: 1.5rem;
            left: 1.5rem;
            width: 45px;
            height: 45px;
          }
        }
      `}</style>
    </>
  );
};

export default BackToTop;
